(() => {
  const SELECTOR = '.atc-banner-carousel__slide-button';
  const ROUTE_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function addVariantsToCart(button) {
    const ids = (button.dataset.variantIds || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

    if (ids.length === 0) return;

    const items = ids.map((id) => ({
      id: Number(id),
      quantity: 1,
      properties: { _source: 'mothers_day_banner' },
    }));

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(ROUTE_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });

      const data = await res.json().catch(() => ({}));

      button.dispatchEvent(
        new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: {
            status: res.ok ? 'success' : 'error',
            error: res.ok ? '' : data.description || 'Could not add to cart',
          },
        })
      );

      if (res.ok) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      }
    } catch (err) {
      button.dispatchEvent(
        new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: { status: 'error', error: 'Network error, please retry' },
        })
      );
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest(SELECTOR);
    if (!button) return;
    e.preventDefault();
    if (button.classList.contains('is-loading')) return;
    addVariantsToCart(button);
  });

  function setupDots(root) {
    const track = root.querySelector('.atc-banner-carousel__track');
    const slides = Array.from(root.querySelectorAll('.atc-banner-carousel__slide'));
    const dots = Array.from(root.querySelectorAll('.atc-banner-carousel__dot'));
    if (!track || slides.length === 0 || dots.length === 0) return;

    const setActive = (idx) => {
      dots.forEach((dot, i) => {
        if (i === idx) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    let scrollTimer = null;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const trackLeft = track.getBoundingClientRect().left;
          let bestIdx = 0;
          let bestDistance = Infinity;
          slides.forEach((slide, i) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
            if (distance < bestDistance) {
              bestDistance = distance;
              bestIdx = i;
            }
          });
          setActive(bestIdx);
        }, 60);
      },
      { passive: true }
    );
  }

  document.querySelectorAll('.atc-banner-carousel').forEach(setupDots);

  document.querySelectorAll('.atc-banner-carousel[data-autoplay="true"]').forEach((root) => {
    const track = root.querySelector('.atc-banner-carousel__track');
    const slides = root.querySelectorAll('.atc-banner-carousel__slide');
    if (!track || slides.length < 2) return;

    const intervalMs = Number(root.dataset.autoplaySpeed || 5) * 1000;
    let index = 0;
    let timer = null;
    let paused = false;

    const tick = () => {
      if (paused) return;
      index = (index + 1) % slides.length;
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };

    const start = () => {
      stop();
      timer = setInterval(tick, intervalMs);
    };
    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    root.addEventListener('mouseenter', () => { paused = true; });
    root.addEventListener('mouseleave', () => { paused = false; });
    track.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    track.addEventListener('touchend', () => { paused = false; }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : start();
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      start();
    }
  });
})();